import React from "react";
import R14, {
  Text,
  View,
  Image
} from "../core";
import { commonStyles } from "../assets/css/commonStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import { responsiveTableStyle } from "../assets/css/responsiveTableStyle";
import Touchable from "./TouchableComponent";
import SearchDataTableComponent from "./SearchDataTableComponent";
import SortDataTableComponent from "./SortDataTableComponent";
import AddMessageIconComponent from "./AddMessageIconComponent";
import FilterIconComponent from "./FilterIconComponent";
import attachedFileIcon from "../assets/images/attachedFileIcon.png";

export default R14.connect(
  class HeaderTitleComponent extends React.Component {

    render() {
      const {
        convertToCSV,
        getPageData,
        isSearchIcon,
        isAddMessage,
        downloadCsv,
        filterIcon,
        dataSort,
        sortingFields,
        searchText
      } = this.props;
      const { isMobileDevice } = this.props.app.dm.notificationDomain.state;
      return (
        <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.flexGrow0, commonStyles.justifyContentSpaceBetween, commonStyles.alignItemsCenter]}>
          <View style={[responsiveTableStyle.pageTitle]}>
            <Text style={[commonStyles.titleTextHeader1, commonFontStyles.workSans]}>
              {this.props.title}
            </Text>
          </View>
          <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.justifyContentFlexEnd, !!isMobileDevice ? null : commonStyles.displayNone]}>
            {isSearchIcon && <SearchDataTableComponent searchText={searchText} getPageData={getPageData}/>}
            {dataSort && <SortDataTableComponent sortingFields={sortingFields} getPageData={getPageData} />}
            {downloadCsv && <View style={[commonStyles.paddingRight16]} >
              <Touchable onPress={() => convertToCSV()}>
                <Image source={attachedFileIcon} style={commonStyles.icon18} />
              </Touchable>
            </View>}
            {!!isAddMessage && <AddMessageIconComponent />}
            {!!filterIcon && <FilterIconComponent />}
        </View>
      </View>
      );
    }
  }
);